'use client';
var classes = {"input":"m_6fa5e2aa"};

export { classes as default };
//# sourceMappingURL=PickerInputBase.module.css.mjs.map
